import type { PlanResponse, Plans } from '@commerce-subscription-webcomponents/sdk';

export const getValidSubscriptionPlans = (
  subscriptionPlans: Plans,
  restrictFromSubscription = false,
): PlanResponse[] => {
  if (!restrictFromSubscription && subscriptionPlans?.plans) {
    return subscriptionPlans.plans.filter((plan) => !plan.restrictPlanOnPdp);
  }
  return [];
};

export const checkIfValidSubscriptionPlansAvailable = (subscriptionPlans: Plans, restrictFromSubscription = false) => {
  const validSubscriptionPlans = getValidSubscriptionPlans(subscriptionPlans, restrictFromSubscription);
  return validSubscriptionPlans.length > 0 ? true : false;
};
